import { Face, FaceType } from "./count-calculator/count-calculator.model";
import { MeshType } from "./shape-type";

export function getOriginalFaceMetaDataMap(meshType: MeshType): FaceMetaDataMap | undefined {
    switch (meshType) {
        case MeshType.Cube:
            return {
                [Face.Front]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 1 },
                [Face.Top]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 2 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 3 },
                [Face.Left]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 4 },
                [Face.Right]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 5 },
            };

        case MeshType.CurvedCube:
            return {
                [Face.Front]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 1 },
                [Face.Top]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 2 },
                [Face.Left]: { originalType: FaceType.HalfPlane, type: FaceType.HalfPlane, materialIndex: 3 },
                [Face.Right]: { originalType: FaceType.HalfPlane, type: FaceType.HalfPlane, materialIndex: 4 },
            };

        case MeshType.CurvedCube2:
            return {
                [Face.Front]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 1 },
                [Face.Top]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 2 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 3 },
                [Face.Left]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 2 },
                [Face.Right]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 2 },
            };

        case MeshType.HalfCylinder:
            return {
                [Face.Front]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Top]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 1 },
                [Face.Left]: { originalType: FaceType.HalfPlane, type: FaceType.HalfPlane, materialIndex: 2 },
                [Face.Right]: { originalType: FaceType.HalfPlane, type: FaceType.HalfPlane, materialIndex: 3 },
            };

        case MeshType.Prism:
            return {
                [Face.Front]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 1 },
                [Face.Top]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: -1 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 2 },
                [Face.Left]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 3 },
                [Face.Right]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 4 },
            };

        case MeshType.SquarePyramid:
            return {
                [Face.Front]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 1 },
                [Face.Top]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: -1 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 2 },
                [Face.Left]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 3 },
                [Face.Right]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 4 },
            };

        case MeshType.Cone:
            return {
                [Face.Front]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Top]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 1 },
                [Face.Left]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Right]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
            };

        case MeshType.Cylinder:
            return {
                [Face.Front]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Top]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 1 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 2 },
                [Face.Left]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Right]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
            };

        case MeshType.HemiSphere:
            return {
                [Face.Front]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Top]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 1 },
                [Face.Left]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Right]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
            };

        case MeshType.RightTriangle:
            return {
                [Face.Front]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Back]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 1 },
                [Face.Top]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
                [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 2 },
                [Face.Left]: { originalType: FaceType.HalfPlane, type: FaceType.HalfPlane, materialIndex: 3 },
                [Face.Right]: { originalType: FaceType.HalfPlane, type: FaceType.HalfPlane, materialIndex: 4 },
            };

        // case MeshType.ConcavePrism:
        //     return {
        //         [Face.Front]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
        //         [Face.Back]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 1 },
        //         [Face.Top]: { originalType: FaceType.Curved, type: FaceType.Curved, materialIndex: 0 },
        //         [Face.Bottom]: { originalType: FaceType.Plane, type: FaceType.Plane, materialIndex: 2 },
        //         [Face.Left]: { originalType: FaceType.HalfPlane, type: FaceType.HalfPlane, materialIndex: 3 },
        //         [Face.Right]: { originalType: FaceType.HalfPlane, type: FaceType.HalfPlane, materialIndex: 4 },
        //     };

        default:
            return undefined;
    }
}

export interface FaceMetaData {
    originalType: FaceType;
    type: FaceType;
    materialIndex: number;
}

export type FaceMetaDataMap = Record<Face, FaceMetaData>;

export const tiltedShapeConfiguration = {
    offsetXforRightAndLeftFace: 18,
    rotationforRightAndLeftFace: 2.02,
    offsetX: 8.5,
    offsetY: 18,
    defaultOffsetY: 9,
};

export enum ValidFacesRange {
    HalfCylinderMinimum = 6,
    HalfCylinderMaximum = 11,
    HemiSphereMinimum = 6,
    HemiSphereMaximum = 7,
    CylinderMinimum = 4,
    CylinderMaximum = 7,
    CurvedCubeMinimum = 6,
    CurvedCubeMaximum = 11,
    CurvedCubeSecondRangeMin = 2,
    CurvedCubeSecondRangeMax = 3,
    SquarePyramidMinimum = 6,
    SquarePyramidMaximum = 7,
    ConeMinimum = 6,
    ConeMaximum = 7,
    PrismRangeMin = 6,
    PrismRangeMax = 11,
    CubeMinimum = 0,
    CubeMaximum = Infinity,
    RightTriangleFirstMinRange = 2,
    RightTriangleFirstMaxRange = 3,
    RightTriangleSecondMinRange = 6,
    RightTriangleSecondMaxRange = 11,
    ConcavePrismFirstMinRange = 2,
    ConcavePrismFirstMaxRange = 3,
    ConcavePrismSecondMinRange = 6,
    ConcavePrismSecondMaxRange = 7,
    ConcavePrismThirdMinRange = 8,
    ConcavePrismThirdMaxRange = 9,
    ConcavePrismFourthMinRange = 11,
    ConcavePrismFourthMaxRange = 11,
    CurvedCube2FirstMinRange = 0,
    CurvedCube2FirstMaxRange = 3,
    CurvedCube2SecondMinRange = 6,
    CurvedCube2SecondMaxRange = 7,
}

export enum DimensionShapeSelector {
    CubeWidth = 3,
    CubeHeight = 3,
    CubeDepth = 3,
    CurvedCubeHeight = 3,
    CurvedCubeSegements = 32,
    CurvedCube2Radius = 1.5,
    CurvedCube2Height = 1.5,
    CurvedCube2Segements = 24,
    HalfCylinderRadius = 1.5,
    HalfCylinderLength = 3,
    HalfCylinderSegments = 24,
    PrismScaleFactor = 1.5,
    SquarePyramidScaleFactor = 1.5,
    PrismRadius = 1.5,
    PrismHeight = 3,
    PrismSegements = 23,
    CylinderRadiusTop = 1.5,
    CylinderRadiusBottom = 1.5,
    CylinderHeight = 3,
    CylinderSegments = 32,
    HemiSphereRadius = 1.7,
    HemisphereWidthSegments = 32,
    HemisphereHeightSegments = 32,
    RightTriangleScaleFactor = 1.5,
    ConcavePrismDepth = 3,
    ConcavePrismSegmenets = 32,
}

export enum DimensionNormalShape {
    CubeWidth = 20,
    CubeHeight = 20,
    CubeDepth = 20,
    CurvedCubeHeight = 20,
    CurvedCubeSegements = 32,
    CurvedCube2Radius = 10,
    CurvedCube2Height = 10,
    CurvedCube2Segements = 24,
    HalfCylinderRadius = 10,
    HalfCylinderLength = 20,
    HalfCylinderSegments = 24,
    PrismScaleFactor = 10,
    SquarePyramidScaleFactor = 10,
    PrismRadius = 10,
    PrismHeight = 20,
    PrismSegements = 23,
    CylinderRadiusTop = 10,
    CylinderRadiusBottom = 10,
    CylinderHeight = 20,
    CylinderSegments = 32,
    HemiSphereRadius = 10,
    HemisphereWidthSegments = 32,
    HemisphereHeightSegments = 32,
    RightTriangleScaleFactor = 10,
    ConcavePrismDepth = 20,
    ConcavePrismSegmenets = 32,
}
